import React, { useState } from 'react';
import '../../css/home/home.css'; // Asegúrate de crear este archivo CSS también
import CardHomeBalance from '../../components/card/CardHomeBalance'
import ButtonHomeTransaction from '../../components/button/ButtonHomeTransaction'
import ButtonHomeWallet from '../../components/button/ButtonHomeWallet'
import CustomTable from '../../components/table/CustomTable';
import ButtonFuctionDashboard from '../../components/button/ButtonFuntionDashboard';
import CardWalletCurrency from '../../components/card/CardWalletCurrency'
import ButtonWalletTransaction from '../../components/button/ButtonWalletTransaction'

import { useNavigate } from 'react-router-dom';


import COPU from '../../assets/currency/copu.png'
import USD from '../../assets/currency/usd.png'
import USDT from '../../assets/currency/usdt.png'

import { ReactComponent as ENVIAR } from '../../assets/IconsColurs/IconsGeneral/send.svg'
import { ReactComponent as RECIBIR } from '../../assets/IconsColurs/IconsGeneral/receive.svg'
import { ReactComponent as CONVERTIR } from '../../assets/IconsColurs/IconsGeneral/exchange.svg'
import { ReactComponent as DEPOSITAR } from '../../assets/IconsColurs/IconsGeneral/buy.svg'
import { ReactComponent as BACK } from '../../assets/IconsColurs/IconsGeneral/chevronLeft.svg'



const WalletUsd = () => {

  const [userOtp, setUserOtp] = useState(false)
  const navigate = useNavigate();

  return (
    <div className="home ">
      <div className='w-full flex flex-col h-[100vh]  py-10 px-6  gap-2 ' >
        <div className='w-full flex justify-between text-center mb-1' >
          <div className='flex flex-row gap-2 justify-end  '  >
            <ButtonFuctionDashboard Icon={BACK} onClick={() => navigate('/dashboard')} />
            <h2 className='text-white text-2xl font-bold leading-8 tracking-tighter	' >Mis Dólares Estadounidenses</h2>
          </div>

        </div>
        <div className='flex flex-row w-full  h-auto justify-around gap-2' >
          <div className='flex flex-row gap-2' style={{ width: '40%' }} >
            <CardWalletCurrency icon={USD} label='USD' balance='$ 0.00' conversion={'$0.00 COP'} />
          </div>
          <div className=' flex flex-row gap-2' style={{ width: '60%' }} >
            <ButtonWalletTransaction Icon={ENVIAR} label={'Enviar'} />
            <ButtonWalletTransaction Icon={RECIBIR} label={'Recibir'} />
            <ButtonWalletTransaction Icon={CONVERTIR} label={'Convertir'} />
          </div>
        </div>
        <div className='w-full h-auto  flex items-center '  >
          <p className=' text-base text-[#8A8A8E]  ' >
            Mis movimientos
          </p>
        </div>
        <div className='w-full h-[100vh]  flex items-start bg-[#1a1b22] rounded-xl  '  >
          <CustomTable filterActive={false} downloadActive={false} datos={false} seeMoreActive={true} />
        </div>
      </div>
    </div >
  );
};

export default WalletUsd;
